import { render, staticRenderFns } from "./MyHonor.vue?vue&type=template&id=18a14c4e&"
import script from "./MyHonor.vue?vue&type=script&lang=js&"
export * from "./MyHonor.vue?vue&type=script&lang=js&"
import style0 from "./MyHonor.vue?vue&type=style&index=0&id=18a14c4e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports